import { render, staticRenderFns } from "./CategoryChange.vue?vue&type=template&id=a39002aa&scoped=true&"
import script from "./CategoryChange.vue?vue&type=script&lang=js&"
export * from "./CategoryChange.vue?vue&type=script&lang=js&"
import style0 from "./CategoryChange.vue?vue&type=style&index=0&id=a39002aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39002aa",
  null
  
)

export default component.exports